import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateComponentModalService } from './translate-component-modal.service';
import { ToasterService } from 'src/app/toaster.service';
import mixpanel from 'mixpanel-browser';
import { I18n } from 'src/app/i18n.service';
import { AppState } from 'src/app/app.service';

@Component({
  selector: 'app-translate-component-modal',
  templateUrl: './translate-component-modal.component.html',
  styleUrls: ['./translate-component-modal.component.scss'],
})
export class TranslateComponentModalComponent implements OnInit {

 @Input() languages: [string, string][] = [];
  @Input() pathLanguage: [string, string] | null = null;
  selectedLang: string = 'none';

  constructor(private modalCtrl: ModalController, private translateModalService: TranslateComponentModalService,
    private toasterService: ToasterService, public i18n: I18n, private appState:AppState
  ) {}
  
  ngOnInit() {
    this.selectedLang =this.appState.get('selectedLanguage')?this.appState.get('selectedLanguage'):'none'
  }
  dismiss() {
    mixpanel.track("User closed the modal by clicking on close before saving language");
    this.modalCtrl.dismiss();
  }

  confirm() {
    if (this.selectedLang === this.appState.get('selectedLanguage') || (this.selectedLang === 'none' && !this.appState.get('selectedLanguage'))) {
      mixpanel.track("User selected the same language as before and closed the modal by clicking on done", { Language: this.selectedLang });
      this.modalCtrl.dismiss();
    }
    else {
      this.translateModalService.saveTranslateLang(this.selectedLang).subscribe((res) => {
        this.appState.set("selectedLanguage", res?.user_language);
        let updateUser = this.appState.get('currentUser')
        updateUser.userLanguage = res?.user_language;
        this.appState.set("currentUser", updateUser);
        mixpanel.track("user selected language stored successfully after clicking on done", { Language: res?.user_language, selectedLang: this.selectedLang })
        this.modalCtrl.dismiss(this.selectedLang);
      }, (err) => {
        mixpanel.track("Error while storing language", { error: err })
        this.toasterService.error(this.i18n.t("Error while saving language, pls try again"))
      }
      )
    }
  }
}
